import cn from 'classnames'
import React from 'react'
import Link from 'redux-first-router-link'
import PropTypes from 'prop-types'

import SidebarLabel from 'components/App/DesktopView/Layout/Sidebar/SidebarLabel'
import customPropTypes from 'util/customPropTypes'
import { paddedSpacing } from './paddedLevelStyle'
import SidebarCount from './SidebarCount'

import styles from './styles.less'

SidebarItem.propTypes = {
  active: PropTypes.bool,
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.symbol]),
  children: customPropTypes.children.isRequired,
  color: PropTypes.string,
  padded: PropTypes.number,
  size: PropTypes.oneOf(['large', 'small']),
  to: customPropTypes.to,
  clickable: PropTypes.bool,
  showBackgroundWhenActive: PropTypes.bool,
  count: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  dotColor: PropTypes.string,
}

SidebarItem.defaultProps = {
  active: false,
  color: 'white',
  padded: 1,
  size: 'small',
  to: null,
  as: undefined,
  clickable: true,
  showBackgroundWhenActive: true,
  count: undefined,
  dotColor: undefined,
}

export default function SidebarItem({
  active,
  activeClassName,
  as: As = 'div',
  children,
  className,
  color,
  padded,
  size,
  to,
  clickable,
  showBackgroundWhenActive,
  count,
  dotColor,
  ...rest
}) {
  const computedClassName = cn(
    styles.SidebarItem,
    {
      [styles.SidebarItem_active]: active,
      [styles.clickable]: clickable,
      [styles.SidebarItem_activeBackground]: showBackgroundWhenActive,
    },
    className
  )

  const content = (
    <SidebarLabel size={size} color={color}>
      {children}
    </SidebarLabel>
  )

  const dotContent = (
    <span
      className={styles.SidebarItem_dot}
      style={{ backgroundColor: dotColor }}
    />
  )

  if (!to)
    return (
      <As
        css={paddedSpacing({ padded, size })}
        className={computedClassName}
        {...rest}
      >
        {!!dotColor && dotContent}
        {content}
        {!!count && <SidebarCount count={count} />}
      </As>
    )
  return (
    <Link
      to={to}
      css={paddedSpacing({ padded, size })}
      className={computedClassName}
      {...rest}
    >
      {!!dotColor && dotContent}
      {content}
      {!!count && <SidebarCount count={count} />}
    </Link>
  )
}
